module.exports = __webpack_public_path__ + "img/banner_generic_top.007bb336.jpg";